import { NxEvent } from '../classes/nx-event.class'

export const useEventBuilderMixin = {
  methods: {
    buildEvent (type, options = {}) {
      return new NxEvent(type, {
        cancelable: false,
        target: this.$el || null,
        relatedTarget: null,
        trigger: null,

        ...options,

        vueTarget: this,
        componentId: this._uid
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nexum/mixins/useEventBuilderMixin.js